export const PATCH_CAMPAIGN = 'PATCH_CAMPAIGN';
export const PATCH_CAMPAIGN_CTA = 'PATCH_CAMPAIGN_CTA';
export const RESET_CAMPAIGN = 'RESET_CAMPAIGN';
export const GET_MESSAGE_CAMPAIGNS = 'GET_MESSAGE_CAMPAIGNS';
export const LOAD_CAMPAIGN_BY_ID = 'LOAD_CAMPAIGN_BY_ID';
export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN';
export const UPDATE_CAMPAIGN = 'UPDATE_CAMPAIGN';
export const SEND_TEST_CAMPAIGN = 'SEND_TEST_CAMPAIGN';
export const PUBLISH_CAMPAIGN = 'PUBLISH_CAMPAIGN';
